import type * as Types from '@/typings'

/** 语言种类 */
export type LangType = 'zh-hans-cn' | 'zh-hant-tw' | 'en' | 'vi' | 'id' | 'ms'

/** 语言 */
export type LanguageType = {
  /** 输出的标签 */
  label: string
  /** 浏览器多语言 */
  lang: string
  /** 传给后端接口的字段 */
  languageType: LangType
  /** antd的多语言 */
  antd: string
  /** 是否隐藏 */
  hidden?: boolean
}

export const LANGUAGE_ENUMS = {
  CHINESE: 'zh',
  ENGLISH: 'en',
} as const

/** 语言 */
export const LANGUAGE: Types.Dict<Omit<LanguageType, 'label'>> = [
  {
    label: 'English',
    lang: 'en',
    antd: 'en_US',
    languageType: 'en',
  },
  {
    label: '中文繁體',
    // 传给i18n获取多语言
    lang: 'zh-TW',
    antd: 'zh_TW',
    languageType: 'zh-hant-tw',
  },
  {
    label: '中文简体',
    lang: 'zh-CN',
    antd: 'zh_CN',
    languageType: 'zh-hans-cn',
  },
  // {
  //   // 马来语
  //   label: 'Bahasa Malayu',
  //   lang: 'ms',
  //   antd: 'ms_MY',
  //   languageType: 'ms',
  // },
  // {
  //   // 越南语
  //   label: 'Tiếng Việt',
  //   lang: 'vi',
  //   antd: 'vi_VN',
  //   languageType: 'vi',
  // },
  // {
  //   // 印尼语
  //   label: 'Bahasa Indonesia',
  //   lang: 'id',
  //   antd: 'id_ID',
  //   languageType: 'id',
  // },
]

/**
 * 绑定教程的链接
 */
export const LESSON_WITHLANG = {
  'zh-CN': 'https://support.onewarehouse.net/hc/zh-cn/sections/5506509289999-%E5%B9%B3%E5%8F%B0%E7%AE%A1%E7%90%86',
  'zh-TW': 'https://support.onewarehouse.net/hc/zh-tw/sections/5506509289999-%E5%B9%B3%E5%8F%B0%E7%AE%A1%E7%90%86',
  en: 'https://support.onewarehouse.net/hc/en-us/sections/5506509289999-Platform-management',
}
export const LINK_LANG = {
  'zh-CN': 'https://support.onewarehouse.net/hc/zh-cn',
  'zh-TW': 'https://support.onewarehouse.net/hc/zh-tw',
  en: 'https://support.onewarehouse.net/hc/en-us',
  ms: 'https://support.onewarehouse.net/hc/ms-my',
  vi: 'https://support.onewarehouse.net/hc/vi-vn',
  id: 'https://support.onewarehouse.net/hc/id',
}

export const DEFAULT_LANG = 'en'

/** 自定义物流匹配规则地址 */
export const RULES_LANG_CONFIG: Record<string, string> = {
  'zh-TW': 'https://support.onewarehouse.net/hc/zh-tw/articles/7054075491471',
  'zh-CN': 'https://support.onewarehouse.net/hc/zh-cn/articles/7054075491471',
  en: 'https://support.onewarehouse.net/hc/en-us/articles/7054075491471',
  id: 'https://support.onewarehouse.net/hc/id/articles/7054075491471',
  ms: 'https://support.onewarehouse.net/hc/ms-my/articles/7054075491471',
  vi: 'https://support.onewarehouse.net/hc/vi-vn/articles/7054075491471',
}

/** 仓库休息时间规则地址 */
export const SHIPMENT_REST_TIME_LANG_CONFIG: Record<string, string> = {
  'zh-TW': 'https://support.onewarehouse.net/hc/zh-tw/articles/7203660506639',
  'zh-CN': 'https://support.onewarehouse.net/hc/zh-cn/articles/7203660506639',
  en: 'https://support.onewarehouse.net/hc/en-us/articles/7203660506639',
  id: 'https://support.onewarehouse.net/hc/id/articles/7203660506639',
  ms: 'https://support.onewarehouse.net/hc/ms-my/articles/7203660506639',
  vi: 'https://support.onewarehouse.net/hc/vi-vn/articles/7203660506639',
}

export const LOGISTICS_SIZE_LIMIT_RULES_CONFIG: Record<string, string> = {
  'zh-TW': 'https://support.onewarehouse.net/hc/zh-tw/articles/7389049923215',
  'zh-CN': 'https://support.onewarehouse.net/hc/zh-cn/articles/7389049923215',
  en: 'https://support.onewarehouse.net/hc/en-us/articles/7389049923215',
  id: 'https://support.onewarehouse.net/hc/id/articles/7389049923215',
  ms: 'https://support.onewarehouse.net/hc/ms-my/articles/7389049923215',
  vi: 'https://support.onewarehouse.net/hc/vi-vn/articles/7389049923215',
}

/**同步订单设置详细说明 */
export const SYNC_ORDER_CONFIG: Record<string, string> = {
  'zh-TW':
    'https://support.onewarehouse.net/hc/zh-tw/articles/11660714028559-%E5%90%8C%E6%AD%A5%E8%A8%82%E5%96%AE%E7%9A%84%E5%95%86%E5%93%81%E5%83%B9%E6%A0%BC%E5%8F%96%E5%80%BC%E8%A8%AD%E5%AE%9A',
  'zh-CN':
    'https://support.onewarehouse.net/hc/zh-cn/articles/11660714028559-%E5%90%8C%E6%AD%A5%E8%AE%A2%E5%8D%95%E8%AE%BE%E5%AE%9A-%E5%95%86%E5%93%81%E4%BB%B7%E6%A0%BC%E4%B8%8E%E5%B8%81%E5%88%AB%E8%A7%84%E5%88%99',
  en: 'https://support.onewarehouse.net/hc/en-us/articles/11660714028559-Synchronize-order-settings-product-price-and-currency-rules',
  id: 'https://support.onewarehouse.net/hc/id/articles/7768543037199',
  ms: 'https://support.onewarehouse.net/hc/ms-my/articles/7768543037199',
  vi: 'https://support.onewarehouse.net/hc/vi-vn/articles/7768543037199',
}
